import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenErrorTemplateComponent } from "../loren-error-template/loren-error-template.component";

@Component({
    selector: "loren-forbidden",
    imports: [TranslocoPipe, LorenErrorTemplateComponent],
    templateUrl: "./loren-forbidden.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loren-forbidden.component.scss"]
})
export class LorenForbiddenComponent {}
